module.exports = __webpack_public_path__ + "img/arrow.0e4fd650.svg";